import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import beachImage from './images/cherryGrove.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Cherry Grove"
      meta={[
        { name: 'description', content: 'Cherry Grove has a lively atmosphere with something for everyone.' },
        { name: 'keywords', content: 'Cherry Grove, Fire Island, Ferries, New York, Long Island, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Cherry Grove">
        <h2>Communities</h2>
        <h1>Cherry Grove</h1>
        <p>Amenities</p>
        <div className="amenities">
          { Amenities.byBeach('Cherry Grove').map(item => (
            <i key={item.text} className={`icon-${item.icon}`} title={item.text} />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="http://www.sayvilleferry.com/">Schedules</Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About Cherry Grove</h1>
          </div>
          <p>
            Cherry Grove is considered one of the gay-meccas in the greater New York area.  
            Its lively atmosphere has something for everyone and continues to be a welcoming place for all.  
            This community boasts fabulous restaurants, a hotel, and unique shops that help create this amazing Fire Island spot.  
            Cherry Grove is also known for its many themed parties, happy hours, and of course the famous, 
            “Miss Fire Island,” drag queen beauty contest.  
          </p>
          <Tip title="Captain's Tip">
            Try to see one of the drag shows while visiting.
          </Tip>
        </div>
        <div className="col-xl-4">
          <Beach image={beachImage} link="/communities/sailors-haven" beach="Cherry Grove" description="Lively atmosphere with something for everyone." className="mx-auto" />
        </div>
      </div>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Cherry Grove is available by <Link to="http://www.sayvilleferry.com/">Sayville Ferry</Link> located in Sayville, NY.
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is available to and from Cherry Grove during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
